import useThreatMetrix from './useThreatMetrix'

export default useThreatMetrix
